import type {FC} from 'react';
import {useState} from 'react';
import {ActionButton} from 'components/PageHeader';
import {CreateSessionDocumentDialog} from '../CreateSessionDocumentDialog';

export const NewSessionDocumentButton: FC = () => {
  const [isOpen, setIsOpen] = useState(false);

  return (
    <>
      <ActionButton
        label="New Document"
        onClick={() => setIsOpen(true)}
        testId="create-document-button"
      />
      <CreateSessionDocumentDialog
        open={isOpen}
        onClose={() => setIsOpen(false)}
      />
    </>
  );
};
